<template>
  <div class="base-wrapper agreement-wrapper">
    <h2 class="second-page-title center bold">请阅读同意以下协议</h2>
    <img
      class="half-drawer-close"
      src="../../assets/close.png"
      @click="backIndex"
    />

    <vix-tab
      v-model="curTabIndex"
      :menu="menu"
      class="agreement-tab"
    >
      <div
        v-for="(item, index) in agreementInfo"
        :key="index"
        class="iframe-wrapper"
      >
        <iframe
          ref="iframe"
          :src="item.agreementLink"
          frameborder="0"
        />
      </div>
    </vix-tab>

    <div class="button-line">
      <button
        class="go-service"
        @click="backIndex"
      >
        完成
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { Tab, ScrollView } from '@mx/vix';
import { VisiblePage } from '@/common';

Vue.use(Tab);
Vue.use(ScrollView);

export default Vue.extend({
  name: 'AgreementItem',

  props: {
    agreementInfo: {
      default: () => [] as AgreementType[],
      type: Array,
    },
    clickIndex: {
      default: 0,
      type: Number,
    },
  },

  data() {
    return {
      curTabIndex: 0,
    };
  },

  computed: {
    menu(): string[] {
      return this.agreementInfo.reduce((acc: string[], cur: any) => {
        acc.push(cur.agreementName);
        return acc;
      }, []);
    },
  },

  watch: {
    // 由于该组件 keep-alive ，还需要 watch 改值
    clickIndex(val) {
      this.curTabIndex = val;
    },
  },

  mounted() {
    this.curTabIndex = this.clickIndex;
  },

  methods: {
    backIndex() {
      this.$emit('toggleVisiblePage', VisiblePage.index);
    },
  },
});
</script>

<style lang="less" scoped>
@import '../../styles/variable.less';

.agreement-wrapper {
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;
  padding: 0 0.36rem 1.86rem;
  background: #fff;
  width: 100vw;

  .tab {
    overflow: initial;
  }

  .agreement-title {
    line-height: 1.1rem;
    font-size: 0.32rem;
    color: @mainText;
  }

  .agreement-tab {
    display: flex;
    flex-direction: column;
    flex: 1;
    font-size: 0.28rem;
    color: @mainText;

    // 覆盖一大堆 vix-tab 的样式
    /deep/ .tab-menu-container {
      &::after,
      .tab-line {
        display: none;
      }

      .tab-menu li {
        font-weight: normal;

        &.tab-active {
          position: relative;
          font-weight: bold;

          &::after {
            content: '';
            position: absolute;
            bottom: 0.18rem;
            left: 50%;
            display: block;
            width: 0.6rem;
            height: 0.06rem;
            background: @yellow;
            border-radius: 0.03rem;
            margin-left: -0.3rem;
          }
        }

        .tab-title {
          line-height: 0.8rem;
          font-size: 0.28rem;
          color: @mainText;
          margin: 0;
        }
      }
    }
  }

  /deep/ .tab-wrap {
    flex: 1;
    margin-left: -0.36rem;
  }

  .iframe-wrapper {
    flex: 1;
    background: #fff;
    box-shadow: 0 0.08rem 0.2rem 0 rgba(0, 0, 0, 0.04);
    border-radius: 0.12rem;
    padding: 0.15rem;
    margin: 0 0.36rem;
    -webkit-overflow-scrolling: touch;
    overflow-y: auto;
    position: relative;

    iframe {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      border: 1px solid rgba(0, 0, 0, 0.06);
    }
  }

  .button-line {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    background: #fff;
    padding: 0.3rem 0.36rem;
    margin: 0;
  }
}
</style>
